module.exports = __webpack_public_path__ + "img/zola.9e5d68f2.png";